<template>
  <section class="quality-accordion">
    <div class="quality-accordion-content">
      <!-- Desktop & Mobile Images -->
      <!-- <img
				:src="shopifyData.backgroundImageDesktop"
				:alt="shopifyData.backgroundImageDesktop.alt || 'Background Image'"
				class="desktop_image"
			/>
			<img
				:src="shopifyData.backgroundImageMob"
				:alt="shopifyData.backgroundImageMob.alt || 'Background Image'"
				class="mob_image"
			/> -->

      <picture class="quality-bg">
        <!-- Mobile -->
        <source :srcset="shopifyData.backgroundImageMob" media="(max-width: 767px)" />

        <!-- Desktop -->
        <source :srcset="shopifyData.backgroundImageDesktop" media="(min-width: 768px)" />

        <!-- Fallback -->
        <img
          :src="shopifyData.backgroundImageDesktop"
          :data-src="shopifyData.backgroundImageDesktop"
          :alt="shopifyData.backgroundImageDesktop.alt || 'Quality Section Background'"
          loading="lazy"
          decoding="async"
          class="quality-bg-img lazyfade"
        />
      </picture>

      <!-- Accordion List -->
      <ul class="accordions">
        <li class="sec_title">{{ shopifyData.sectionTitle }}</li>

        <li
          v-for="(item, index) in shopifyData.accordionData"
          :key="index"
          class="accordianlistItem"
        >
          <button
            class="qualityAccordion"
            aria-label="Toggle FAQ Answer"
            @click="toggleAccordion(index)"
          >
            <img
              :src="item.accordionButtonIcon"
              alt="square icon"
              height="13"
              width="13"
              loading="lazy"
              aria-hidden="true"
              aria-label="Square Icon"
            />
            {{ item.accordionButton }}
          </button>

          <div ref="panels" class="qualityAccordion_panel" v-html="item.accordionPanel"></div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: null,
    };
  },
  mounted() {
    // Initialize panel heights to 0
    const panels = this.$refs.panels;
    if (panels && panels.length) {
      panels.forEach((panel) => (panel.style.height = '0'));
    }
    this.fadeImageOnLoad();
  },
  methods: {
    toggleAccordion(index) {
      // Toggle active index
      this.activeIndex = this.activeIndex === index ? null : index;

      // Wait for DOM update
      this.$nextTick(() => {
        const panels = this.$refs.panels;
        if (panels && panels.length) {
          panels.forEach((panel, i) => {
            if (i === index) {
              panel.style.height = this.activeIndex === index ? panel.scrollHeight + 'px' : '0';
            } else {
              panel.style.height = '0';
            }
          });
        }
      });
    },
    fadeImageOnLoad() {
      const img = this.$el.querySelector('.lazyfade');
      if (!img) return;

      img.addEventListener('load', () => {
        img.classList.add('loaded');
      });

      // Safari fix (immediate "complete")
      if (img.complete) {
        img.classList.add('loaded');
      }
    },
  },
};
</script>

<style scoped>
/* Placeholder Blur */
.lazyfade {
  opacity: 0;
  filter: blur(20px);
  transform: scale(1.05);
  transition:
    opacity 0.8s ease,
    filter 0.8s ease,
    transform 0.8s ease;
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* Loaded image */
.lazyfade.loaded {
  opacity: 1;
  filter: blur(0);
  transform: scale(1);
}
.accordions {
  max-width: 334px;
  width: 100%;
  position: absolute;
  bottom: 53px;
  left: 41px;
}

.accordianlistItem {
  margin-top: 12px;
}

.qualityAccordion {
  display: flex;
  border: none;
  width: 100%;
  cursor: pointer;
  font-family: 'Helvetica Neue', sans-serif;
  position: relative;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  color: #fff;
  text-transform: uppercase;
  gap: 14px;
}

.qualityAccordion svg {
  margin-right: 10px;
}

.qualityAccordion::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 6px;
  background: url('https://cdn.shopify.com/s/files/1/0689/7618/1550/files/Vector_11_1.svg?v=1710839462')
    no-repeat center;
  background-size: 12px;
  transition: 0.3s;
}
.sec_title {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 14px;
  line-height: 18.31px;
  color: #fff;
  font-weight: 700;
}

.qualityAccordion.active::after {
  transform: translateY(-50%) rotate(-180deg);
}

.qualityAccordion_panel {
  font-family: 'Helvetica Neue', sans-serif;
  position: relative;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  color: #fff;
  overflow: hidden;
  transition: 0.3s;
  height: 0;
}
.qualityAccordion.active ~ .qualityAccordion_panel p {
  padding-top: 16px;
  padding-bottom: 10px;
}
.quality-accordion-content {
  position: relative;
}

.desktop_image,
.mob_image {
  min-height: 664px;
  margin-top: -1px;
}
.desktop_image {
  display: block;
  width: 100%;
}
.mob_image {
  display: none;
  width: 100%;
}

@media (max-width: 991px) {
  .accordions {
    bottom: 40px;
    left: 5px;
    padding: 10px;
  }

  .desktop_image {
    display: none;
  }
  .mob_image {
    display: block;
  }
  .lazyfade {
    aspect-ratio: auto;
  }
}
</style>

<style>
/* Add this non-scoped style for v-html content */
.qualityAccordion_panel p {
  padding-top: 16px;
  padding-bottom: 10px;
}
</style>
